'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODULE_NAME = undefined;
exports.init = init;

var _tracking = require('../utils/tracking');

var MODULE_NAME = exports.MODULE_NAME = 'ga-tracking';

function init(_ref) {
  var el = _ref.el;

  el.addEventListener('click', function (e) {
    var _getData = getData(el),
        eventCategory = _getData.eventCategory,
        eventAction = _getData.eventAction,
        eventLabel = _getData.eventLabel,
        eventValue = _getData.eventValue;

    (0, _tracking.trackGtag)({ eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel, eventValue: eventValue });
  });
}

function getData(el) {
  return {
    eventCategory: el.dataset.eventCategory,
    eventAction: el.dataset.eventAction,
    eventLabel: el.dataset.eventLabel,
    eventValue: el.dataset.eventValue
  };
}